'use strict';

import { Component } from 'react';

import './MaintenanceBanner.scss';
import UserStore from '../../stores/UserStore';

export default class MaintenanceBanner extends Component {
    constructor(props) {
        super(props);

        this.state = {
            drawer: false,
            user: UserStore.getUser(),
            dismissed: false,
        };
    }

    componentDidMount = () => {
        UserStore.addChangeListener(this.onUserStoreChange);
        setTimeout(() => this.setState({drawer: true}));
    }

    componentWillUnmount = () => {
        UserStore.removeChangeListener(this.onUserStoreChange);
    }

    onUserStoreChange = () => {
        this.setState({user: UserStore.getUser()});
    }

    closeModal = () => {
        this.setState({drawer: false}, () => {
            setTimeout(() => {
                this.setState({dismissed: true});
            }, 350);
        });
    }

    render = () => {
        // if (process.env.SHOW_MAINTENANCE_BANNER !== 'true') {
        //     return <span />;
        // }

        const { drawer, user, dismissed } = this.state;

        if (!user || dismissed) {
            return <span />;
        }

        return (
            <div className="maintenance-banner" data-drawer={drawer}>
                <div className="inner-container">
                    <p>Eatlove will be on scheduled maintainance on 28 May 2026 from 10 pm PST to 6 am PST</p>
                    <button className="close-btn" onClick={this.closeModal} aria-label="Close">
                        <i className="icon-close-x" />
                    </button>
                </div>
            </div>
        );
    }
}
